import UserDocumentSerializer from './user-document';

export default class VisitorDocumentSerializer extends UserDocumentSerializer {
  attrs = { ...this.attrs, externalAttachments: { serialize: false } };
}
